import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import useColors from "../api/hooks/useColors";

const CustomTooltipBorder = styled(
  ({ className, borderColor, placement = "top", ...props }) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow
      placement={placement}
    />
  )
)(({ theme, borderColor }) => {
  const colors = useColors();

  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: colors.common_black,
      boxShadow: "0px 1px 2px 0px " + colors.box_shadow,
      maxWidth: "400px",
      fontSize: 11,
      borderTop: `1.5px solid ${borderColor || colors.info_main}`,
      borderRadius: "6px",
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
      "&::before": {
        boxShadow: "0px 1px 2px 0px " + colors.box_shadow,
      },
    },
  };
});

export default CustomTooltipBorder;
